module.exports = __webpack_public_path__ + "static/frontpage-image-1-min-f416f1080aab0a43176dcbb82c23d123.jpg";